import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { BreadCrumbModel } from '../campaign-3/models/campaign-3-breadcrumb.model';
import { Campaign3KontableComponent } from '../campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { NotificationService } from './services/notification-service.service';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/primeng';
import { Router } from '@angular/router';
import {
  DELETE_STATES, RESEND_STATES,
  getStatusColor, getStatusLabel,
  NotificationCommand, ScheduleResponse, ScheduleStatus,
  StatusColor, UpdateScheduleStateRequest,
  MessageInstanceActionStatusDto
} from './model/notification-model';

@Component({
  selector: 'app-notification-management',
  templateUrl: './notification-management.component.html',
  styleUrls: ['./notification-management.component.css']
})
export class NotificationManagementComponent implements OnInit {

  constructor(
    private notificationService: NotificationService,
    public srvCalendar: CalendarTranslateService,
    private translateService: TranslateService,
    private srvMessage: MessageService,
    public router: Router
  ) {}

  readyTable = false;
  @ViewChild('notificationManager') kontableComponent: Campaign3KontableComponent;

  breadcrumbs: Array<BreadCrumbModel> = [];
  paginationType = Campaign3KontableComponent.ServerPagination;
  dateFilter   = Campaign3KontableComponent.DateFilter;
  numberFilter = Campaign3KontableComponent.NumberFilter;
  textFilter   = Campaign3KontableComponent.TextFilter;
  selectFilter = Campaign3KontableComponent.SelectFilter;
  noFilter     = Campaign3KontableComponent.NoFilter;
  pageSubject  = 'notification-management';

  startDate: Date | null = null;
  endDate:   Date | null = null;

  showBreadCrumb = true;
  showMenu = false;
  currentOpenedRow: any = null;

  displayDeleteDialog = false;
  notificationToDelete: any = null;

  selectedNotificationRow: ScheduleResponse = null;
  showNotificationStatusModal = false;

  notificationCommand = NotificationCommand;
  getStatusLabel = getStatusLabel;
  getStatusColor = getStatusColor;
  StatusColor = StatusColor;
  statusList: { label: string, value: string }[] = [];


ngOnInit(): void {


  Observable.zip(
    this.notificationService.getActionStatus(),
    this.translateService.get('breadCrumb.notificationManagement')
  ).subscribe(([statusRes, label]) => {
    
 this.statusList = [
  {
    label: '',
    value: null
  },
  ...statusRes.data.map((dto: MessageInstanceActionStatusDto) => ({
    label: getStatusLabel(dto.status),
    value: dto.status
  }))
];

    this.breadcrumbs = [
      { code: 'bc1', description: label, routerLink: '/notification-management' }
    ];

      this.readyTable = true;
  });
}
  hasCommand(status: string, command: NotificationCommand): boolean {
    if (command === NotificationCommand.VIEW_STATUS) return true;
    if (command === NotificationCommand.DELETE)      return DELETE_STATES.indexOf(status) !== -1;
    if (command === NotificationCommand.RESEND)      return RESEND_STATES.indexOf(status) !== -1;
    return false;
  }

  breadcrumbClicked(breadcrumb: BreadCrumbModel): void {
    if (breadcrumb.routerLink) this.router.navigate([breadcrumb.routerLink]);
  }

  clearDateFields(): void { this.startDate = null; this.endDate = null; }
  clearDateFilter(): void { this.startDate = null; this.endDate = null; }

  toggleMenu(row: ScheduleResponse): void {
    if (this.currentOpenedRow === row.challengeId) {
      this.showMenu = !this.showMenu;
    } else {
      this.showMenu = true;
      this.currentOpenedRow = row.challengeId;
    }
  }

  deleteNotification(row: ScheduleResponse): void {
    this.notificationToDelete = row;
    this.displayDeleteDialog = true;
    this.showMenu = false;
  }

  closePopupDelete(): void {
    this.displayDeleteDialog = false;
    this.notificationToDelete = null;
  }

  resendNotification(row: ScheduleResponse): void {
    const request = new UpdateScheduleStateRequest();
    request.challengeId = row.challengeId;
    request.requestedStatus = ScheduleStatus.TO_BE_UPPLOAD_CSV;

    this.notificationService.updateScheduleState(request)
      .subscribe(() => this.kontableComponent.refresh());
  }

  onDefinitiveDelete(notification: ScheduleResponse): void {
    const request = new UpdateScheduleStateRequest();
    request.challengeId = notification.challengeId;
    request.requestedStatus = ScheduleStatus.STOP_IN_PROCESS;

    this.notificationService.updateScheduleState(request)
      .subscribe(() => this.kontableComponent.refresh());
    this.closePopupDelete();
  }

  openNotificationStatus(row: ScheduleResponse): void {
    this.selectedNotificationRow = row;
    this.showNotificationStatusModal = true;
  }

  closeNotificationStatusModal(): void {
    this.showNotificationStatusModal = false;
    this.selectedNotificationRow = null;
    this.kontableComponent.refresh();
  }

  @HostListener('document:click', ['$event'])
  onClick(event: any): void {
    if (!event.target.closest('.dropdown-menu') && event.target.closest('.d-flex') === null) {
      this.showMenu = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/views/notification/notification-management.component.ts